import React, { useCallback, useState } from "react";
import { func, bool } from "prop-types";
import { oidcSelector } from "../../../../selectors/oidcSelectors";
import { useSelector } from "react-redux";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import "./addAsyncJobModal.css";
import { CloseIcon } from "../../../../assets";
import { IconButton } from "@material-ui/core";
import LabeledInput from "../../../../components/formik/LabeledInput";

const AddAsyncJobModal = ({ isOpen, toggle, values, handleAdd }) => {
  const oidc = useSelector(oidcSelector);

  const isMaster = !!oidc.user.profile.role.find((x) => {
    return x === "master";
  });

  const isManager = !!oidc.user.profile.role.find((x) => {
    return x === "manager";
  });

  const isCoordinator = !!oidc.user.profile.role.find((x) => {
    return x === "coordinator";
  });

  const isClient = !!oidc.user.profile.role.find((x) => {
    return x === "client";
  });

  const optionsValues = useCallback(() => {
    if (isMaster || isClient) {
      return [
        { key: "Activate", value: "ActivateClients" },
        { key: "Deactivate", value: "DeactivateClients" },
        { key: "Escalate", value: "SetEscalated" },
        { key: "Approve High risk", value: "SetApprovedHighRisk" },
        { key: "Reject Applicant", value: "SetRejectedHighRisk" },
        { key: "Recalculate", value: "RecalculateClients" },
        { key: "Rescore", value: "RescoringClients" },
        { key: "Negative Media", value: "NegativeMedia" },
        { key: "Semantic Negative Media", value: "SemanticNegativeMedia" },
        { key: "Watchlist Regular Search", value: "ResearchingClients" },
      ];
    }

    if (isManager) {
      return [
        { key: "Activate", value: "ActivateClients" },
        { key: "Deactivate", value: "DeactivateClients" },
        { key: "Approve High risk", value: "SetApprovedHighRisk" },
        { key: "Reject Applicant", value: "SetRejectedHighRisk" },
        { key: "Recalculate", value: "RecalculateClients" },
        { key: "Rescore", value: "RescoringClients" },
        { key: "Negative Media", value: "NegativeMedia" },
        { key: "Semantic Negative Media", value: "SemanticNegativeMedia" },
        { key: "Watchlist Regular Search", value: "ResearchingClients" },
      ];
    }

    if (isCoordinator) {
      return [
        { key: "Activate", value: "ActivateClients" },
        { key: "Deactivate", value: "DeactivateClients" },
        { key: "Escalate", value: "SetEscalated" },
        { key: "Reject Applicant", value: "SetRejectedHighRisk" },
        { key: "Recalculate", value: "RecalculateClients" },
        { key: "Rescore", value: "RescoringClients" },
        { key: "Negative Media", value: "NegativeMedia" },
        { key: "Semantic Negative Media", value: "SemanticNegativeMedia" },
        { key: "Watchlist Regular Search", value: "ResearchingClients" },
      ];
    }

    return [{ key: "", value: null }];
  }, [isMaster]);

  const [type, setType] = useState(optionsValues()[0].value);
  const [description, setDescription] = useState("");

  const setCurrentType = (type) => {
    var value = type.target.value;
    setType(value);
  };
  const typeInDescriptionField = (type) => {
    var value = type.target.value;
    setDescription(value);
  };

  const hasDescription = () => {
    var result =
      type === "SetApprovedHighRisk" ||
      type === "SetRejectedHighRisk" ||
      type === "SetEscalated";
    return result;
  };

  const checkBeforeHandleAdd = (values, type) => {
    if (hasDescription()) {
      // adds comment to dto when needed
      return handleAdd(
        { ...values, CommentForSetScoreStatus: description },
        type
      );
    }
    return handleAdd(values, type);
  };

  return (
    <React.Fragment>
      <Modal isOpen={isOpen}>
        <ModalHeader
          close={
            <IconButton style={{ top: -5, right: -10 }} onClick={toggle}>
              <CloseIcon />
            </IconButton>
          }
        >
          Mass action
        </ModalHeader>
        <ModalBody>
          <div>
            <Input type="select" onChange={setCurrentType} value={type}>
              {optionsValues().map((op) => (
                <option key={op.key} value={op.value}>
                  {op.key}
                </option>
              ))}
            </Input>
            {hasDescription() && (
              <div>
                <LabeledInput
                  type="textarea"
                  name="commentForSetScoreStatus"
                  onChange={typeInDescriptionField}
                />
                <div className="confirm-info red left">
                  Description should be between 15 and 200 characters.
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="add-async-job-modal-button confirm-button"
            color="primary"
            onClick={() => checkBeforeHandleAdd(values, type)}
            disabled={hasDescription() && description.length < 15}
          >
            Create
          </Button>
          <Button
            className="add-async-job-modal-button cancel-button"
            color="secondary"
            onClick={toggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

AddAsyncJobModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
};

export default AddAsyncJobModal;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/add-async-job-modal/AddAsyncJobModal.jsx